import { render, staticRenderFns } from "./ProfilePopover.vue?vue&type=template&id=51eadd94&scoped=true"
import script from "./ProfilePopover.vue?vue&type=script&lang=js"
export * from "./ProfilePopover.vue?vue&type=script&lang=js"
import style0 from "./ProfilePopover.vue?vue&type=style&index=0&id=51eadd94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51eadd94",
  null
  
)

export default component.exports